"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _theme = _interopRequireDefault(require("../../../theme"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var Warning = function Warning() {
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("path", {
    fill: _theme["default"].scaleLevel20,
    d: "M.713 7.325c1.331-3.31 4.553-5.124 7.709-6.147C12.717-.216 17.238 0 17.915.028c.74.03 4.382.108 8.487 1.45 2.581.843 5.2 2.417 7.559 4.474 2.176 1.897 3.873 4.324 4.879 7.693 1.02 3.42 1.484 6.713.912 9.562-.998 4.968-3.624 8.505-3.789 8.743-2.144 3.097-4.934 4.565-7.422 5.7-4.088 1.867-7.78 2.41-8.81 2.345-.414-.026-4.17-.582-8.17-2.875-2.27-1.3-4.617-3.298-6.5-6.196C2.63 27.183 1.672 23.419.888 18.863-.06 13.363-.44 10.188.713 7.325Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: _theme["default"].scaleLevel100,
    fillRule: "evenodd",
    d: "M30.37 26.7 20.45 9.79c-.2-.34-.7-.34-.9 0L9.63 26.7c-.2.34.05.77.45.77h19.84c.4 0 .65-.43.45-.77ZM21.8 9.02c-.8-1.37-2.8-1.37-3.61 0L8.28 25.93c-.8 1.37.2 3.07 1.8 3.07h19.84c1.6 0 2.6-1.71 1.8-3.07L21.8 9.02ZM20 14c.41 0 .75.3.75.68v5.4c0 .37-.34.68-.75.68s-.75-.3-.75-.68v-5.4c0-.37.34-.68.75-.68Zm0 11.25c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5-1.5.67-1.5 1.5.67 1.5 1.5 1.5Z"
  }));
};
var _default = exports["default"] = Warning;